<template>
    <base-button
        @click="loadNextStep"
        :is-disabled="!selectionsComplete"
        variant="shine"
        :class="{ 'opacity-40 cursor-not-allowed' : !selectionsComplete }"
        class="w-44 h-16"
    >
        {{ $t('NEXT') }}

        <img
            src="../assets/icons/arrow.svg"
            alt=""
            width="40"
            height="15"
            class="ml-4"
        >
    </base-button>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButton from './BaseButton.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButton,
        },

        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },

            currentStep() {
                return this.appStore.currentStep;
            },

            controllerState() {
                return this.customizerStore.viewController?.state || [];
            },

            selectedOptions() {
                return this.controllerState.filter((x) => !x.component.placeholder) || [];
            },

            allGroups() {
                return this.customizerStore.viewController?.blueprint.groups;
            },

            totalSteps() {
                return this.allGroups?.filter((group) => group.custom['oe-is-step'] === 'true').length || 0;
            },

            selectionsComplete() {
                if (this.isMobile) {
                    if (this.isMobile && this.currentStep.includes('select')) {
                        const groupName = this.currentStep.split('select')[1];

                        return this.selectedOptions.map((x) => x.placement.name).indexOf(groupName) !== -1;
                    }
                }

                return this.selectedOptions.length === this.totalSteps - 1;
            },
        },

        methods: {
            loadNextStep() {
                this.appStore.loadNextStep();
            },
        },
    };
</script>
